<template>
  <div class="container" id="goods-edit">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <el-breadcrumb separator="">
        <el-breadcrumb-item>
          <div class="div1">九航云选</div>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/matrix/serverAdmin' }">
          <div class="div2">服务商详情</div>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content page-title">
      <el-menu
        :default-active="currentIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="clickbtn"
      >
        <el-menu-item
          v-for="(item, index) in btns"
          :index="index.toString()"
          :key="index"
          >{{ item }}</el-menu-item
        >
      </el-menu>
      <!-- <h2>用户详情</h2> -->
    </div>
    <div class="content">
      <h2>服务商详情</h2>
      <!-- <el-button
        v-for="(item, index) in btns"
        :key="index"
        :type="currentIndex == index ? 'primary' : ''"
        @click="clickbtn(index)"
      >
        {{ item }}
      </el-button> -->
      <userInfo v-if="currentIndex == 0" :phone="phone"></userInfo>
      <orderInfo v-if="currentIndex == 1" :phone="phone"></orderInfo>
      <addressInfo v-if="currentIndex == 2" :phone="phone"></addressInfo>
      <commissionRecord
        v-if="currentIndex == 3"
        :phone="phone"
      ></commissionRecord>
      <fansRecord v-if="currentIndex == 4" :phone="phone"></fansRecord>
      <rechargeRecord v-if="currentIndex == 5" :phone="phone"></rechargeRecord>
      <integralRecord v-if="currentIndex == 6" :phone="phone"></integralRecord>
      <cashRecord v-if="currentIndex == 7" :phone="phone"></cashRecord>
    </div>
  </div>
</template>

<script>
import userInfo from './components/userInfo.vue'
import orderInfo from './components/orderInfo.vue'
import addressInfo from './components/addressInfo.vue'
import commissionRecord from './components/commissionRecord.vue'
import rechargeRecord from './components/rechargeRecord.vue'
import integralRecord from './components/integralRecord.vue'
import fansRecord from './components/fansRecord.vue'
import cashRecord from './components/cashRecord.vue'
export default {
  components: {
    userInfo,
    orderInfo,
    addressInfo,
    cashRecord,
    commissionRecord,
    rechargeRecord,
    integralRecord,
    fansRecord
  },
  data () {
    return {
      phone: '',
      userId: '',
      currentIndex: '0',
      name: '---',
      dialogUser: false,
      tableData: [
        {}, {}, {}
      ],
      btns: ['个人信息', '订单信息', '地址信息', '佣金记录', '粉丝记录', '充值记录', '积分记录', '提现记录']
    }
  },
  created () {
    this.phone = this.$route.query.phone
  },
  methods: {
    clickbtn (index) {
      this.currentIndex = index
    }
  }
}
</script>
<style scoped>
.div1 {
  margin-left: -16px;
  background: url(../../assets/breadcrumb2.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2d7edf;
}

.div2 {
  margin-left: -16px;
  background: url(../../assets/breadcrumb1.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
}
.dialog-search {
  display: flex;
  width: 46%;
  justify-content: space-between;
  margin-top: 10px;
  margin-left: 10px;
}
</style>
